import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { useGetProfileQuery } from "../../service/auth/api";
import CommonBreadcrumb from "../../components/CommonBreadcrumb";


const ManageProfile = () => {

  const navigate = useNavigate();
  const { data: profileData } = useGetProfileQuery(undefined);
  const authUser = useSelector((state: any) => state.auth.user);
  const user = profileData?.data || authUser;

  return (
    <>
      <CommonBreadcrumb
        title="Manage Profile"
        breadcrumbItems={[
          { label: "Dashboard", onClick: () => navigate("/dashboard") },
          { label: "Manage Profile" },
        ]}
      />

      <div className="cards view_page">
        <div className="table_header">
          <div className="left_s">
            <h2>General Details</h2>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/manage-profile/edit")}><EditIcon /> Edit Profile</Button>
          </div>
        </div>
        <div className="gap_p">
          <div className="vew_img w_100">
            <h6>Image</h6>
            <figure>
              <img alt="user" src={user?.image || "/static/images/admin_icon.png"} />
            </figure>
          </div>
          <div className="w_33">
            <h6>Name</h6>
            <p>{user?.fullName || "Admin"}</p>
          </div>
          <div className="w_33">
            <h6>Email Id</h6>
            <p>{user?.email || "admin@gmail.com"}</p>
          </div>
          <div className="w_33">
            <h6>Phone Number</h6>
            <p>{user?.countryCode || "+91"} {user?.phone || "9876543210"}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageProfile;
